import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Routes } from '../../App/App.routes';

const wrapStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  padding: '4px 10px',
  borderRadius: 12,
  background: 'rgba(0,0,0,0.05)',
  fontSize: 12,
  color: '#444',
  margin: '8px 0',
};
const dotStyle = (color) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  background: color,
  display: 'inline-block',
});
const linkStyle = { marginLeft: 4, color: '#1565c0', textDecoration: 'none' };

// Label and dot color per enrollment source. Default (teaPublished) reads as
// the authoritative TEA figure; roster/manual are district overrides.
const SOURCES = {
  teaPublished: { label: 'TEA Published (3-12)', color: '#1565c0' },
  roster: { label: 'Roster Count', color: '#2e7d32' },
  manual: { label: 'Manual Settings', color: '#b26a00' },
};

// Small provenance note on the district A-F report showing where the campus
// enrollment weighting came from, with a shortcut to the setting that controls it.
const EnrollmentSourceBadge = ({ enrollmentSource }) => {
  if (!enrollmentSource) return null;
  const { label, color } = SOURCES[enrollmentSource] || SOURCES.roster;
  return (
    <div style={wrapStyle} title="Source of the grade 3-12 enrollment counts used to weight campuses">
      <span style={dotStyle(color)} />
      Enrollment: {label}
      <Link to={`/${Routes.settings}/${Routes.advancedSettings}`} style={linkStyle}>
        Change
      </Link>
    </div>
  );
};

EnrollmentSourceBadge.propTypes = {
  enrollmentSource: PropTypes.string,
};

export default EnrollmentSourceBadge;
